import type { TrackerService } from '@web-rendering/groundcontrol-core';
import { reportError } from '@web-rendering/groundcontrol-monitoring';

export const setupHeavyAdInterventionObserver = (
  id: string | null,
  placeholder: HTMLElement,
  trackerService: TrackerService<Record<string, string | object>>,
  options?: { callerId?: string; partnerId?: string; networkId?: string }
) => {
  // Check if browser is Firefox and ReportingObserver exists
  const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
  if (isFirefox || !('ReportingObserver' in window)) return;

  try {
    const sendReports = (reports: Report[]) => {
      for (const report of reports) {
        if (
          report.type === 'intervention' &&
          report.body &&
          'id' in report.body &&
          report.body.id === 'HeavyAdIntervention'
        ) {
          trackerService.trackHeavyAdIntervention();
          reportError(new Error('HeavyAdIntervention detected'), {
            context: 'helpers:heavy-ad-intervention',
            report,
            id: id ?? undefined,
            payloadId: id,
            placeholderAttributes: placeholder.dataset || {},
            callerId: options?.callerId,
            partnerId: options?.partnerId,
            networkId: options?.networkId
          });
        }
      }
    };

    const observer = new ReportingObserver(
      (reports) => {
        sendReports(reports);
      },
      { buffered: true }
    );

    observer.observe();

    // Add pagehide event listener to capture any pending reports
    window.addEventListener('pagehide', () => {
      const reports = observer.takeRecords();
      sendReports(reports);
      observer.disconnect(); // Clean up the observer
    });
  } catch (error) {
    // Silently fail if there's any error in setting up the observer
  }
};
